export const EnderecoModel = (obj) => {
  return {
    logradouro: obj.logradouro,
    complemento: obj.complemento,
    numero: obj.numero,
    bairro: obj.bairroNome,
    cidade: obj.cidadeNome,
    uf: obj.ufSigla,
    cep: obj.cep,
  };
};
